export default __webpack_public_path__ + "static/media/Group 42.9d0ed74e.png";